BaseModel = require './base_model.coffee'

class global.Variable extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: { type: String }
    placeholder: { type: String }
    placeholder_name: { type: String }
    target_method: { type: String }
  }



// WEBPACK FOOTER //
// ./src/models/variable.coffee